/* eslint-disable prettier/prettier */
import * as gql from 'fake-tag';

export const v3Params = `
canonicalUrl
pageTitle
description
keywords
nofollow
noindex
ogImage
ogTitle
ogType
ogUrl`;

export const v3SEOFragment = {
  // `fake-tag` ships no type declarations, so `gql` resolves to `any`. Typing it requires
  // switching all 46 `import * as gql` sites to a default import — tracked in EPS-3772.
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
  seoContent: gql`
  fragment v3SEOFragment on visionTemplateEntry_Entry {
    ${v3Params}
  }
`,
};
